/**
 * Component to render SCA Investor Relations page
 */
const InvestorRelationsPage = (): React.ReactElement => {
  return (
    <div
      className="mb-10 font-public-sans"
      data-testid="investor-relations-page-component"
    >
      <p>
        <strong>Objectives of the Award</strong>
      </p>

      <ul className="list-outside list-disc pb-6 pl-8">
        <li>
          To recognise companies that embody the spirit of good corporate
          governance and corporate transparency; and hence adopt and implement
          best practices in investor relations (IR);
        </li>
        <li>
          To motivate other listed companies to improve the quality of their
          disclosure and raise their standard of corporate governance in their
          communication with shareholders and the investing public;
        </li>
      </ul>

      <p>
        <strong>Categories of the Award</strong>
      </p>

      <p>The Award will be presented in the following categories:</p>

      <ul className="list-outside list-disc pb-6 pl-8">
        <li>Companies with market capitalisation of S$1 billion and above;</li>
        <li>
          Companies with market capitalisation of S$300 million to less than S$1
          billion;
        </li>
        <li>
          Companies with market capitalisation of less than S$300 million;
        </li>
        <li>REITs & Business Trusts;</li>
        <li>First-Year Listed companies;</li>
      </ul>

      <p>
        <strong>Selection and Judging Process</strong>
      </p>

      <p>
        The selection and judging process consists of a three-stage process:
      </p>

      <p>
        In Stage 1, all listed companies are subjected to a preliminary
        screening using the following sources:
      </p>

      <ul className="list-outside list-disc pb-6 pl-8">
        <li>
          The company&apos;s Singapore Governance and Transparency Index score;
        </li>
        <li>
          Dedicated IR link and IR contact on the company&apos;s website and/or
          annual report;
        </li>
      </ul>

      <p>
        In Stage 2, a final shortlist of companies is identified using the
        criteria (described below).
      </p>

      <p>
        In Stage 3, a panel of judges reviews and evaluates the shortlisted
        candidates based on the information provided by the companies and
        evaluators.
      </p>

      <p>
        <strong>Criteria</strong>
      </p>

      <p>
        The following criteria are used to identify the final shortlist of
        companies:
      </p>

      <ul className="list-outside list-disc pb-6 pl-8">
        <li>Responsiveness of the IR contact to cold calls and emails;</li>
        <li>
          Comprehensiveness/ user-friendliness of the IR link, specifically the
          types and quality of information provided (e.g. annual reports,
          presentations, etc.) and speed of downloads;
        </li>
        <li>
          Whether the company submits requested information on the IR function
          and practices;
        </li>
        <li>
          Whether there are negative news items related to IR, such as being on
          the SGX watchlist, late announcement of financial or AGM results,
          modified audit opinion, and queries about disclosures and
          announcements;
        </li>
      </ul>

      <div className="mt-12 text-xs">
        <p>
          For more information, please contact the Singapore Institute of
          Directors:
        </p>

        <ul className="mb-6 list-none">
          <li>Mr Edwin Lee;</li>
          <li>Email: edwin@sid.org.sg;</li>
          <li>DID: 6011 0100 / 6422 1188;</li>
        </ul>

        <ul className="mb-6 list-none">
          <li>Singapore Institute of Directors;</li>
          <li>168, #11-03 Robinson Rd, Capital Tower, 068912;</li>
        </ul>

        <p>OR</p>

        <ul className="list-none">
          <li>Ong Yu Fan</li>
          <li>The Business Times</li>
          <li>Email: yufanong@sph.com.sg</li>
          <li>DID: 6319 2235</li>
          <li>1000 Toa Payoh North</li>
          <li>Podium Level 3, Singapore 318994</li>
        </ul>
      </div>
    </div>
  );
};

export default InvestorRelationsPage;
